/**
 * @license
 * Copyright 2022 Superflows.dev
 * SPDX-License-Identifier: MIT
 */

import {SfChartBar} from '../sf-chart-bar.js';
// import { stub } from 'sinon';
// import {fixture, assert} from '@open-wc/testing';
import {assert} from '@open-wc/testing';
// import {html} from 'lit/static-html.js';

//const TIMEOUT = 2000;
suite('sf-chart-bar > left menu', () => {

  test('is defined', () => {
    const el = document.createElement('sf-chart-bar');
    assert.instanceOf(el, SfChartBar);
  });


});

